import React from 'react'
import Home from '../Components/Services/Home/Home'
import Service from '../Components/Services/ServiceSection/Service'

const ServicePage = () => {
  return (
    <>
        <Home />
        <Service />
    </>
  )
}

export default ServicePage